<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center container-background">
    <div class="card border-0 shadow-lg result-card">

        <div class="card-header text-center border-0 py-5 text-white" [ngClass]="isSuccess ? 'success' : 'danger'">
            <div class="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 icon-circle">
                <span class="fs-2 fw-bold">
                    {{ isSuccess ? '✓' : '✕' }}
                </span>
            </div>

            <h5 class="fw-semibold mb-1 text-white fs-3">
                {{ isSuccess ? 'Signing Successful!' : 'Signing Failed' }}
            </h5>

            <p class="mb-0 opacity-75">
                {{ isSuccess
                ? 'Your document has been electronically signed.'
                : 'We were unable to complete the signing.' }}
            </p>
        </div>

        <div class="card-body p-4 py-5">
            <div class="container bg-light rounded-3 p-4">
                <div class="row align-items-center py-2 border-bottom">
                    <div class="col text-muted small fw-bold">📌 TRANSACTION ID</div>
                    <div class="col-auto text-break">
                        <pre>6a7f6f08189f41cb91c94e730e8dc381</pre>
                    </div>
                </div>

                <div class="row align-items-center py-2 border-bottom">
                    <div class="col text-muted small fw-bold">✔️ STATUS</div>
                    <div class="col-auto" [ngClass]="isSuccess ? 'text-success' : 'text-danger'">
                        <pre>{{ isSuccess ? 'Success' : 'Failed' }}</pre>
                    </div>
                </div>

                <div class="row align-items-center py-2">
                    <div class="col text-muted small fw-bold">🗓️ COMPLETED AT</div>
                    <div class="col-auto">
                        <pre>2026-01-06 00:47:36</pre>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>